const guestRegEmailVerifyOTPMapper = (response) => {
    if (response) {
        return {
            isClient: response.isCli,
            isGuest: response.isGuest,
            message: response.msg,
            emailOTPValidated: true,
        };
    }
    return {};
};
export default guestRegEmailVerifyOTPMapper;
